export default "__VITE_ASSET__CTK1JAqc__"